import React, { useState } from 'react';

import { Flex } from '@chakra-ui/react';

import Header from '../../Components/Header';
import Sidebar from '../../Components/Sidebar';

import routes from '../../routes';

import EmailCredentials from './EmailCredentials';
import PhoneCredentials from './PhoneCredentials';
import EmailSignature from './EmailSignature';

import { Box, Text } from '@chakra-ui/react';

const AccountSettings = () => {
  return (
    <>
      <Header />
      <Flex direction="row" position="relative" w="100%" h="100vh">
        <Sidebar routes={routes} />
        <Box px={'10rem'}>
          <Text fontSize="3xl" textAlign={'center'} fontWeight={'bold'}>
            Account Details
          </Text>
          <EmailCredentials />
          <PhoneCredentials />
          <EmailSignature />
        </Box>
      </Flex>
    </>
  );
};

export default AccountSettings;
